import React, {Fragment } from 'react';
import { connect } from 'react-redux';

import { withReportSubscription } from 'State/report/withReportSubscription';
import { NotesReportFieldEnum } from 'Common/FieldEnum';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';
import { Filter, Main } from 'Containers/';
import { STUDENT_NOTES_REPORT_FORM_NAME } from 'Common/FormEnum';
import NotesReportForm from './NotesReportForm';

const NotesReportContainer = ({ getReport, getExcelFile, reportFetching, sitesLoading }) => {
  const getMainProps = () => {
    return {
      toolbox: {
        formName: STUDENT_NOTES_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: reportFetching,
          disabled: reportFetching || sitesLoading,
        },
        shown: true,
      },
    };
  };

 const handleSubmit = (values) => {
   if(values.ReportFormat === reportFormatEnum.Excel){
    getExcelFile('reports/NotesReport', 'StudentNotesReport', values)
   }
   else{
    getReport('reports/NotesReport', values);
   }

  }

  return (
    <Fragment>
      <Filter title={'Notes'} />
      <Main {...getMainProps()}>
        <NotesReportForm
          onSubmit={handleSubmit}
          initialValues={{
            [NotesReportFieldEnum.ReportFormat]: reportFormatEnum.PDF,
            [NotesReportFieldEnum.SortBy]: 0,
            [NotesReportFieldEnum.Site]: 'ALL',
          }}
        />
      </Main>
    </Fragment>
  );
};


const mapStateToProps = ({ CommonState }) => {
  return {
    sitesLoading: CommonState.sites.loading,
  };
};

export const NotesReport = withReportSubscription(
  connect(mapStateToProps)(NotesReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/notesreport/NotesReport.js